<template>
    <v-card rounded="lg" outlined>
        <v-row no-gutters>
            <v-col cols="12" md="auto" class="border-md-end min-w-md-200px min-w-lg-280px">
                <v-layout justify-center align-center class="w-100 h-100 pa-20">
                    <v-img :aspect-ratio="166 / 36" width="166" height="36" max-width="166" contain :src="company.logo?.src">
                        <v-fade-transition>
                            <v-overlay v-if="!company.logo?.src" absolute light color="white">
                                <image-overlay>{{ company.name }}</image-overlay>
                            </v-overlay>
                        </v-fade-transition>
                    </v-img>
                </v-layout>
            </v-col>
            <v-col cols="12" md="">
                <div class="pa-20 pa-md-24">
                    <v-row align="center">
                        <v-col cols="12" md="" class="mb-10 mb-md-0">
                            <v-row align="center" class="row--small">
                                <v-col cols="auto">
                                    <h5 class="page-text--lg font-weight-medium">
                                        {{ form.name }}
                                    </h5>
                                </v-col>
                                <v-col cols="12" md="auto">
                                    <employment-form :value="value" @show="show">
                                        <template #activator="{ attrs, on }">
                                            <v-btn v-bind="attrs" v-on="on" small block color="primary">자세히 보기</v-btn>
                                        </template>
                                    </employment-form>
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="12" md="auto">
                            <v-row align="center" class="row--small font-size-12">
                                <v-col md="auto">
                                    <v-row class="row--x-small">
                                        <v-col cols="auto">
                                            등록일
                                        </v-col>
                                        <v-col cols="auto">
                                            {{ createdAt }}
                                        </v-col>
                                    </v-row>
                                    <v-row class="row--xx-small">
                                        <v-col cols="auto">
                                            서명일
                                        </v-col>
                                        <v-col cols="auto">
                                            {{ signedAt }}
                                        </v-col>
                                    </v-row>
                                </v-col>
                                <v-col cols="auto">

                                    <!-- 서명 전 -->
                                    <employment-form v-if="!value.isSigned" :value="value" @show="show">
                                        <template #activator="{ attrs, on }">
                                            <v-btn v-bind="attrs" v-on="on" small outlined color="primary">서명하기</v-btn>
                                        </template>
                                    </employment-form>
                                    
                                    <!-- 서명 후 -->
                                    <v-chip v-else label color="grey-ec" text-color="grey-1">서명완료 <v-icon size="16" class="ml-4">mdi-check</v-icon></v-chip>

                                </v-col>
                            </v-row>                            
                        </v-col>
                    </v-row>
                </div>
            </v-col>
        </v-row>
    </v-card>
</template>

<script>
import dayjs from 'dayjs';

import EmploymentForm from "@/components/dashboard/person/employment/employment-form.vue";
import ImageOverlay from "@/components/dumb/image-overlay.vue";
export default {
    components: {
        EmploymentForm,
        ImageOverlay
    },
    props:{
        value: { type: Object, default: ()=>({}) }
    },
    methods:{
        show(){
            this.$emit("show");
        }
    },
    computed:{
        company(){
            return this.value.company;
        },
        form(){
            return this.value.form;
        },
        createdAt(){
            return dayjs(this.value?.createdAt).format("YYYY. MM. DD. HH:mm");
        },
        signedAt(){
            return this.value?.signedForm?.createdAt ? dayjs(this.value?.signedForm?.createdAt).format("YYYY. MM. DD. HH:mm") : "-";
        }
    }
}
</script>

<style lang="scss" scoped>
.v-chip{
    &::before{
        display: none;
    }
}
.v-chip.v-size--default {
    font-weight: 500;
    height: 28px;
    font-size: 1.2rem;
    padding: 0 12.4444444444px;
}
@media (min-width: 1024px){
    .v-chip.v-size--default {
        height: 36px;
        font-size: 1.4rem;
    }
}
</style>